class Geolocation {
  constructor() {
    this.geocoder = new window.google.maps.Geocoder();
  }

  getCurrentPosition() {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          resolve(position);
        }, (error) => {
          reject(new Error('Can not get position'));
        });
      } else {
        reject(new Error('Browser does not support geolocation.'));
      }
    });
  }

  geocoding(request) {
    return new Promise((resolve, reject) => {
      this.geocoder.geocode(request, (response) => {
        if (response.length === 0) {
          reject(Error(`geocoding ${JSON.stringify(request)}: not found`));
        } else {
          resolve(response);
        }
      });
    });
  }
}

export const geolocation = new Geolocation();



// WEBPACK FOOTER //
// ./src/helpers/geolocation.js